module.exports = __webpack_public_path__ + "assets/img/36_509_big.da17e9b5.jpg";